import moment from 'moment';
import { baseUrl, enableHybrid, enableOnPremise, reportRequestTimeout, routerApp } from '../app.module';
import { httpRequestGenerator } from '../services/utilities';
import { exportOffshoreReports } from '../utils/export-offshore-reports';

routerApp.controller('offshoreReportController', ['$rootScope', '$scope', '$stateParams', '$http', '$state', 'notify', 'ReportsOffshoreService', 'ReportsOffshoreApiService',
function($rootScope, $scope, $stateParams, $http, $state, notify, ReportsOffshoreService, ReportsOffshoreApiService) {

    $scope.unlocodeRegex = /^[A-Z]*$/
    $rootScope.selectedLevels = ['vessel-reports', 'create-new-report', 'offshore-report'];

    const isBDNActive = () => {
        if (!$scope.carryOverReport) return false
        if (!$scope.carryOverReport.bdn_based_reporting) return false

        return true
    }

    $scope.report = {
        bdn_based_reporting: isBDNActive(),
        consumptions: [{}]
    }

    if ($stateParams.report != undefined) {
        $scope.report = $stateParams.report;
        $scope.viewReport = $stateParams.viewReport;
    }

    $scope.useShorePower = $scope.report.shore_power !== undefined || $scope.report.shore_power_hours !== undefined

    const requestFunc = httpRequestGenerator(enableOnPremise, $http);

    const OPTIONAL_KEYS = ['bdn2', 'bdn3', 'bdn4', 'consumptionMt', 'consumption2Mt', 'consumption3Mt', 'consumption4Mt']

    $scope.isSaveDisabled = function() {
        const keys = Object.keys($scope.reportForm).filter((key: string) => !key.startsWith('$')) as string[]
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i]
            if (OPTIONAL_KEYS.includes(key)) continue
            const value = $scope.reportForm[key]
            if (value.$valid) {
                return false
            }
        }
        return true
    }

    const getCarryoverData = () => {
        if ($scope.report.report_number) {
            return ReportsOffshoreService.getPreviousReport($scope.report.report_number)
        }

        const reports = ReportsOffshoreService.getReports()
        if (!reports?.length) return null
        return reports[0]
    }
    // TODO #83621 - remove next line once getCarryoverData is actually used
    getCarryoverData() // call here or build breaks due to 'unused' function

    const getCarryoverBDN = () => {
        const tanks = $scope.carryOverReport?.stock?.tanks || {}
        if (Object.keys(tanks).length === 0) return []

        const bdnNumbers = Object.keys(tanks)
            .reduce((prev, curr) => [...prev, tanks[curr].bdn_number], [])
            .filter((bdn) => bdn)

        return bdnNumbers
    }

    const getAlreadySelectedBDN = () => {
        return $scope.report.consumptions.map((consumption) => consumption.bdn_number)
    }

    const getAlreadySelectedFuelGrade = () => {
        return $scope.report.consumptions.map((consumption) => consumption.fuel_grade)
    }

    const getConsumptionIds = () => {
        if (isBDNActive()) {
            return getCarryoverBDN()
        }

        return [
            'HFO',
            'LFO',
            'ULSMGO2020',
            'MFO',
            'VLSFO2020'
        ]
    }

    $scope.addNewConsumption = () => {
        $scope.report.consumptions.push({})
    }

    $scope.removeConsumptionByIndex = (index) => {
        $scope.report.consumptions = $scope.report.consumptions.filter((_, i) => i !== index);
    }

    $scope.isBDNActive = () => {
        return isBDNActive()
    }

    $scope.exportReport = (report) => {
        exportOffshoreReports(
            [report],
            `offshore_export_${report.report_number}`
        )
    }

    $scope.$watch('useShorePower', (useShorePower) => {
        if (useShorePower) return
    
        delete $scope.report.shore_power
        delete $scope.report.shore_power_hours
    })

    $scope.$watch('report.consumptions', (newValues) => {
        if (!newValues) return
        newValues.forEach((consumption) => {
            if ((isBDNActive() && !consumption.bdn_number) || (!isBDNActive && !consumption.fuel_grade)) {
                delete consumption.main_engine
                delete consumption.aux_engine
                delete consumption.boiler
            }
        })
    }, true)

    $scope.hasOldStyleConsumptions = () => {
        return $scope.report.hasOwnProperty('bdn_1') && $scope.report.hasOwnProperty('consumption_1_Mt')
    }

    $scope.isAnyConsumptionSelected = () => {
        return $scope.report.consumptions.some((consumption) => consumption.bdn_number || consumption.fuel_grade)
    }

    $scope.$watchGroup([
        'report.report_from',
        'report.report_to',
    ], function(newValues) {
        if (!newValues || newValues.length !== 2) return

        const from = newValues[0]
        const to = newValues[1]
        if (!from || !to) return

        updateReportPeriod(from, to)
    })

    const updateReportPeriod = (from, to) => {
        const fromTime = moment(from, 'DD/MM/YYYY HH:mm')
        const toTime = moment(to, 'DD/MM/YYYY HH:mm')
        const duration = moment.duration(toTime.diff(fromTime))
        const toDST = toTime.isDST() ? 1 : 0
        const fromDST = fromTime.isDST() ? 1 : 0
        const durationHours = duration.asHours() + (toDST - fromDST)

        if (durationHours < 0) return
        $scope.report.report_period = durationHours
    }

    $scope.getBdnOptions = function (index: number) {
        const consumptionIds = getConsumptionIds()
        const alreadySelected = getAlreadySelectedBDN()
        const activeOption = $scope.report.consumptions[index].bdn_number
        const filtered = consumptionIds.filter((bdn) => {
            const isActiveOption = activeOption === bdn
            return (isActiveOption || !alreadySelected.includes(bdn)) && bdn
        })

        // only add empty option if option hasnt been selected for this index
        if ($scope.report.consumptions[index].bdn_number || $scope.report.consumptions[index].fuel_grade) {
            filtered.unshift('')
        }

        return filtered
    }

    $scope.getFuelGradeOptions = function (index: number) {
        const consumptionIds = getConsumptionIds()
        const alreadySelected = getAlreadySelectedFuelGrade()
        const activeOption = $scope.report.consumptions[index].fuel_grade
        const filtered = consumptionIds.filter((fuel_grade) => {
            const isActiveOption = activeOption === fuel_grade
            return (isActiveOption || !alreadySelected.includes(fuel_grade)) && fuel_grade
        })
        
        return filtered
    }

    $scope.getFuelGradeOptions = function (index: number) {
        const consumptionIds = getConsumptionIds()
        const alreadySelected = getAlreadySelectedFuelGrade()
        const activeOption = $scope.report.consumptions[index].fuel_grade
        const filtered = consumptionIds.filter((fuel_grade) => {
            const isActiveOption = activeOption === fuel_grade
            return (isActiveOption || !alreadySelected.includes(fuel_grade)) && fuel_grade
        })
        
        return filtered
    }

    $scope.deleteReport = function(report) {
        const vesselId = $rootScope.selectedVessel.id
        const reportId = report._id
        if (!vesselId || !reportId) return

        ReportsOffshoreApiService.deleteReport($rootScope.selectedVessel.id, report._id).then((response) => {
            notify({message: 'Report deleted.', duration: 2000, classes: ['ok-notification']});
            $('.modal-backdrop').remove();
            ReportsOffshoreService.removeReportFromList(report._id)
            $state.go('site.vesselOffshorePerformance');
        }, (error) => {
            notify({message: 'Failed to delete report.', duration: 2000, classes: ['bad-notification']});
        })
    }

    $scope.getLatestDepartureReportNumber = function() {
        const reports = ReportsOffshoreService.getReports()
        if (!reports?.length) return 

        const lastDepartureReport = reports.find(r => r.event_type === 'departure')
        return lastDepartureReport?.report_number
    }

    $scope.canModifySavedReport = function() {
        const lastDepartureReportNumber = $scope.getLatestDepartureReportNumber()
        if (isNaN(lastDepartureReportNumber)) return true
        return lastDepartureReportNumber <= $scope.report.report_number
    }

    $scope.saveReport = function(report, update = false) {
        if (!report) return

        const url = [
            `${baseUrl}${$rootScope.selectedVessel.id}/offshoreReports`,
            report._id ? `/${report._id}` : '',
            `?update=${update ? 'true' : 'false'}`
        ].join('')
        const method = report._id ? 'PUT' : 'POST'
        const options = (enableHybrid || enableOnPremise) ? {timeout: reportRequestTimeout * 1000} : {};
        requestFunc({url, method, data: report, ...options})
            .then(function (response, status, headers, config) {
                if (response.data) {
                    report._id = response.data._id
                    report.report_number = response.data.report_number
                    report.status = response.data.status
                    ReportsOffshoreService.addReportToList(report)
                }
                notify({message: 'Report saved.', duration: 2000, classes: ['ok-notification']});
            }, function (data, status, header, config) {
                notify({message: 'Report save failed.', duration: 2000, classes: ['bad-notification']});
            })
    }

    $scope.submitReport = function(report) {
        const url = [
            `${baseUrl}${$rootScope.selectedVessel.id}/offshoreReports`,
            report._id ? `/${report._id.$oid}` : '',
            '?submit=true'
        ].join('');
        const method = report._id ? 'PUT' : 'POST'
        const options = (enableHybrid || enableOnPremise) ? {timeout: reportRequestTimeout * 1000} : {};
        requestFunc({url, method, data: report, ...options})
            .then(function (response, status, headers, config) {
                notify({message: 'Report submitted.', duration: 2000, classes: ['ok-notification']});
                $state.go('site.vesselOffshorePerformance');
            }, function (data, status, header, config) {
                notify({message: 'Report submission failed.', duration: 2000, classes: ['bad-notification']});
            })
    }
}]);
